export const GET_USER_SALES_INVOICES = gql`
    query GetUserSalesInvoices($invoiceToType: Hierarchy!, $id: Int!) {
        getUserSalesInvoices(invoiceToType: $invoiceToType, id: $id) {
            id
            invoiceItems {
                id
                ledgerAccount
                description
                netAmount
                totalNet
                totalVat
                lineTotal
                quantity
            }
            to
            date
            sageInvoiceNumber
            totalNetAmount
            totalVatAmount
            totalInvoiceAmount
            status
        }
    }
`;
